import React, { Component } from 'react';
import { Layout, Row, Col, Button } from 'antd';
import './styles.css';
import Service from './Service';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getUserData,
  getDataUserCompany,
  getModalTrue,
  setQuestionsFilial,
} from '../../redux/actions';
import { obterLogo } from '../../components/ModalLogomarca/services';

import btnInsta from '../../images/btnInstagram.png';
import btnZap from '../../images/btnWhatsApp.png';

const { Header, Content, Footer } = Layout;

class Quiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      indice_blue: null,
      showButton: true,
      critica: '',
      elogio: '',
      nome: '',
      celular: '',
      email: '',
      arrResponse: [],
      subPerguntas: [],
      rateValue: [],
      checkSubPerguntas: [],
      logoCliente: '',
      unidadeSemNome: false,
      respostaUnica: false,
      // A tela so pode ser desenhada quando TUDO que decide o que aparece ja
      // chegou: os dados da filial, se existe logomarca e se a unidade e "sem
      // nome". Antes o render era liberado so por dataFilial, e a logo chegava
      // depois - o nome da empresa aparecia e era substituido pela logo (a
      // "piscada"). logoCliente vazio nao servia como sinal: significava tanto
      // "ainda nao verifiquei" quanto "nao tem logo".
      pronto: false,
      loading: true,
      temRedeSocial: false,
      exibirGoogle: false,
      exibirTrip: false,
      exibirInsta: false,
      exibirWhatsApp: false,
      urlGoogle: '',
      urlTrip: '',
      urlInsta: '',
      urlWhats: '',
      textoInsta: '',
      textoZap: '',
      exibirRedes: false,
    };
    this.service = new Service();

    if (typeof window.Tawk_API === 'object') {
      let hideTawkToInteval = setInterval(function() {
        if (
          typeof window.Tawk_API.hideWidget !== 'function' ||
          typeof window.Tawk_API.isChatHidden !== 'function'
        )
          return;

        window.Tawk_API.hideWidget();

        if (window.Tawk_API.isChatHidden()) {
          clearInterval(hideTawkToInteval);
        }
      }, 100);
    }
  }

  async componentDidMount() {
    const { idEmpresa, idFilial } = this.props.match.params;

    if (idEmpresa && idFilial) {
      this.setState({
        idEmpresa: Number(idEmpresa),
        idFilial: Number(idFilial),
      });

      const url = window.location.href;

      let quiosque = undefined;

      if (url.includes('quiosque')) {
        quiosque = url;
      }

      // As quatro buscas sao independentes entre si - em paralelo a tela
      // espera a mais lenta, nao a soma de todas (antes eram 4 idas a rede
      // em sequencia, e carregarLogo ainda podia fazer uma 5a).
      const [unidadeSemNome, dadosFilial, , resultRedes] = await Promise.all([
        this.service.getUnidadeSemNome(idFilial),
        this.getQuestionsFilial(Number(idFilial)),
        this.carregarLogo(Number(idEmpresa), Number(idFilial)),
        this.service.listarRedeSocialPorFilial(idFilial),
      ]);

      this.setState({ unidadeSemNome });

      // Um dispatch so, com o objeto COMPLETO (filial + perguntas + beneficio)
      // mais o unidadeSemNome. Esse ultimo vai junto porque a tela seguinte
      // (QuizSteps) monta a pergunta do NPS com o nome da filial e precisa
      // dele ja no PRIMEIRO render - sem isso ela buscava por conta propria e,
      // como o questionsFilial chega instantaneo do Redux, o nome aparecia e
      // sumia quando a busca respondia.
      this.props.setQuestionsFilial({ ...dadosFilial, unidadeSemNome });

      const redes = resultRedes.object;

      let google = false;
      let googleUrl = '';
      let trip = false;
      let tripUrl = '';
      let insta = false;
      let instaUrl = '';
      let zap = false;
      let zpUrl = '';
      let exibirRedes = false;
      let txtCritica = '';
      let txtElogio = '';
      let txtInsta = '';
      let txtZap = '';

      if (!quiosque) {
        if (redes && redes.length > 0) {
          exibirRedes = true;

          const goo = redes.filter(x => x.tipo === 'Google');

          if (goo && goo.length > 0) {
            google = true;
          } else {
            google = false;
          }

          const trp = redes.filter(x => x.tipo === 'TripAdvisor');

          if (trp && trp.length > 0) {
            trip = true;
          } else {
            trip = false;
          }

          const ig = redes.filter(x => x.tipo === 'Instagram');
          if (ig && ig.length > 0) {
            insta = true;
            instaUrl = ig[0].urlAcesso;
            txtInsta = ig[0].texto;
          } else {
            insta = false;
          }

          const zp = redes.filter(x => x.tipo === 'WhatsApp');

          if (zp && zp.length > 0) {
            zap = true;
            zpUrl = zp[0].urlAcesso;
            txtZap = zp[0].texto;
          } else {
            zap = false;
          }
        }
      }

      this.setState({
        // Libera o desenho da tela so agora, com tudo decidido - ver o
        // comentario de `pronto` no estado inicial.
        pronto: true,
        loading: false,
        temRedeSocial: exibirRedes,
        exibirGoogle: google,
        exibirInsta: insta,
        exibirTrip: trip,
        exibirWhatsApp: zap,
        urlGoogle: googleUrl,
        urlTrip: tripUrl,
        urlInsta: instaUrl,
        urlWhats: zpUrl,
        critica: txtCritica,
        elogio: txtElogio,
        textoInsta: txtInsta,
        textoZap: txtZap,
      });
    } else {
      // TODO: sair dessa tela
      console.log('TODO: sair dessa tela');
    }

    try {
      let queryString = window.location.search || '';

      if (queryString.startsWith('?')) {
        queryString = queryString.substring(1);
      }

      var queryStringKeys = queryString
        .split('&')
        .filter(v => v)
        .map(v => (v.split('=')[0] || '').toLowerCase());

      if (queryStringKeys.indexOf('quiosque') >= 0) {
        window.sessionStorage.setItem('quiosque', window.location.href);
      }
    } catch (error) {
      console.error(error);
    }
  }

  // Recebe o idFilial por parametro: roda em paralelo com as outras buscas,
  // entao nao pode depender de um setState anterior ja ter sido aplicado.
  getQuestionsFilial = async idFilial => {
    const result = await this.service.getQuestionsFilial(
      idFilial || this.state.idFilial
    );
    const data = result.object;

    this.setState({
      dataFilial: data,
    });

    // Devolve o dado em vez de despachar aqui: quem chama junta com o
    // unidadeSemNome e manda pro Redux UMA vez, com o objeto completo.
    // Despachar em dois passos exigiria reler this.props.questionsFilial -
    // que esta tela nem mapeia - e acabava gravando um objeto sem filial
    // nem perguntas, deixando a pergunta do NPS com o texto generico.
    return data;
  };

  getNomeFilial(nome) {
    return this.state.unidadeSemNome ? '' : `(${nome})`;
  }

  getValueLocalStorage(idEmpresa, idFilial) {
    // Obtém todos os cookies e divide-os em um array
    const cookies = document.cookie.split(';');
    // Loop através de todos os cookies
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();

      // Verifica se o cookie começa com o nome desejado
      if (cookie.startsWith(`${idEmpresa}:${idFilial}=`)) {
        // Obtém o valor do cookie
        const cookieValue = cookie.substring(
          `${idEmpresa}:${idFilial}=`.length,
          cookie.length
        );

        // Retorna o valor decodificado
        return JSON.parse(decodeURIComponent(cookieValue));
      }
    }

    // Se o cookie não for encontrado, retorna null
    return null;
  }

  getRespostaUnica() {
    const { idEmpresa, idFilial } = this.props.match.params;

    const respostaFilial = this.getValueLocalStorage(idEmpresa, idFilial);

    this.setState({
      respostaUnica: respostaFilial,
    });
  }

  // Baixa a imagem de verdade (nao so a URL) e resolve quando ja estiver no
  // cache do navegador, pronta pra pintar na tela sem atraso. Sem isso, o
  // <img> entrava no DOM com a URL certa, mas o navegador só começava a
  // baixar os bytes NAQUELE momento - o texto ao lado (que e so texto,
  // pinta na hora) aparecia primeiro, e a logo "pipocava" um instante
  // depois. Nunca deixa a tela travada esperando: se a imagem falhar ou
  // demorar mais de 3s, resolve mesmo assim (a logo so aparece um pouco
  // mais lenta nesse caso raro, em vez de bloquear o questionario inteiro).
  preCarregarImagem = url =>
    new Promise(resolve => {
      if (!url) {
        resolve();
        return;
      }
      const img = new Image();
      const timeout = setTimeout(resolve, 3000);
      img.onload = () => {
        clearTimeout(timeout);
        resolve();
      };
      img.onerror = () => {
        clearTimeout(timeout);
        resolve();
      };
      img.src = url;
    });

  carregarLogo = async (idEmpresa, idFilial) => {
    let url = '';
    let planoEmpresa = 0;

    const resultFilial = await obterLogo(idEmpresa, idFilial);
    url = resultFilial.url;
    planoEmpresa = resultFilial.planoEmpresa;

    if (!resultFilial.url) {
      const resultEmpresa = await obterLogo(idEmpresa, 0);
      url = resultEmpresa.url;
      planoEmpresa = resultEmpresa.planoEmpresa;
    }

    await this.preCarregarImagem(url);

    this.setState({
      logoCliente: url,
    });

    if (planoEmpresa === 4 || planoEmpresa === 5 || planoEmpresa === 6) {
      this.getRespostaUnica();
    }
  };

  handleInsta() {
    window.open(this.state.urlInsta, '_blank');
  }

  handleWhatsApp() {
    window.open(this.state.urlWhats, '_blank');
  }

  render() {
    return !this.state.pronto || !this.state.dataFilial ? (
      <div className="root-loading">
        <img src="/loading.gif" />
        <span>Quase pronto...</span>
      </div>
    ) : !this.state.respostaUnica ? (
      <>
        <Layout>
          <Content
            style={{
              padding: '24px 16px 0',
              backgroundColor: '#FFF',
            }}
          >
            <Row style={{ flexDirection: 'row', marginTop: 50 }}>
              <Col
                xs={{ span: 24 }}
                md={{ span: 12, offset: 6 }}
                lg={{ span: 12, offset: 6 }}
                style={{ fontSize: '18pt', fontWeight: 'lighter' }}
              >
                {this.state.logoCliente && (
                  <Row
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img src={this.state.logoCliente} class="logo-cliente" />
                  </Row>
                )}
                <Row>
                  <p style={{ fontSize: '22pt' }}>Olá!</p>
                </Row>
                <Row
                  style={{
                    flexDirection: 'row',
                    textAlign: 'center',
                    marginTop: 20,
                  }}
                >
                  <Col span={24}>
                    {!this.state.logoCliente && (
                      <>
                        <p
                          style={{
                            fontWeight: 'bold',
                            marginBottom: '0px',
                            fontSize: '22pt',
                          }}
                        >
                          {this.state.dataFilial &&
                            this.state.dataFilial.filial.nomeEmpresa}
                        </p>
                        <p>
                          {this.state.dataFilial &&
                            this.getNomeFilial(
                              this.state.dataFilial.filial.nome
                            )}
                        </p>
                      </>
                    )}
                    <p
                      style={{
                        marginBottom: '0px',
                      }}
                    >
                      {`${
                        !this.state.logoCliente ? 'gostaria' : 'Gostaríamos'
                      }`}{' '}
                      de ouvir sua <br />
                      <strong style={{ whiteSpace: 'pre' }}>
                        opinião sincera.
                      </strong>
                    </p>
                  </Col>
                </Row>
                <Row
                  style={{
                    flexDirection: 'row',
                    textAlign: 'center',
                    marginTop: 50,
                  }}
                >
                  {this.state.dataFilial && this.state.dataFilial.beneficio ? (
                    <Col span={24}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.dataFilial.beneficio.textoInicial,
                        }}
                      ></div>
                    </Col>
                  ) : (
                    <Col span={24}>
                      <p>
                        Leva apenas alguns segundos. Sua opinião nos ajuda a
                        melhorar pensando em você.
                      </p>
                    </Col>
                  )}
                  <Button
                    type="ghost"
                    style={{
                      marginTop: 20,
                      fontWeight: 'normal',
                      paddingLeft: '30px',
                      paddingRight: '30px',
                      textTransform: 'uppercase',
                      height: 'auto',
                      fontSize: '28pt',
                    }}
                    onClick={() =>
                      this.props.history.push({
                        pathname: `/blue/questionario/${this.state.idEmpresa}/${this.state.idFilial}/steps`,
                      })
                    }
                  >
                    COMEÇAR
                  </Button>
                </Row>
              </Col>
            </Row>
          </Content>
        </Layout>
      </>
    ) : (
      <Layout>
        <Content
          style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '100px',
            backgroundColor: '#FFF',
          }}
        >
          {this.state.logoCliente && (
            <Row
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img src={this.state.logoCliente} class="logo-cliente" />
            </Row>
          )}

          <Row>
            <p style={{ fontSize: '22pt', textAlign: 'center' }}>
              <strong>Obrigado!</strong> <br></br> Você já fez esta avaliação
              recentemente.
            </p>
          </Row>

          {this.state.temRedeSocial && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                width: '100%',
                paddingLeft: '10%',
              }}
            >
              <Button
                onClick={() => this.handleInsta()}
                className="btn-rede-social follow-us"
              >
                <img src={btnInsta} alt="Siga a gente no instagram" />
                <label>{this.state.textoInsta}</label>
              </Button>
              <Button
                onClick={() => this.handleWhatsApp()}
                className="btn-rede-social follow-us"
              >
                <img src={btnZap} alt="Fale com a gente no whatsapp" />
                <label>{this.state.textoZap}</label>
              </Button>
            </div>
          )}
        </Content>
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { getUserData, getDataUserCompany, getModalTrue, setQuestionsFilial },
    dispatch
  );

const mapStateToProps = store => ({
  filialId: store.userData.filialId,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Quiz);
